import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: 'RTO',
  components: {
    BasicSelect,
    Paginate,
    Pagination,
    DatePicker,
    Loader,
  },
  data: function() {
    return {
      // totalRows:0,
      selectedmerchant:{value:'',text:''},
			merchantList:[],
      awbno: '',
      shippingcompany: '',
      listRTOproductData: [],
      shippingcompanyList: [],
      // pageno: 0,
      // totalPage: 0,
      // pageLimit: 10,
      // currentPage: 0,
      totalPage: 0,
      totalRows:0,
      currentPage: 1,
      pageLimit:10,
      isLoading: false,
      resultCount: '',
      clientListData: [],
      clientid: '',
      searchFlag: false,
      showSelectClient: false,
      showSelectWarehouse: false,
      showSelectMerchant:false,
      ClientErr: '',
      WarehouseErr: '',
      client: '',
      warehouse: '',
      todate: '',
      fromdate: '',
      shippingid: '',
      orderid: '',
      listWarehouseData: [],
      listMerchantData: [],
      merchant:'',

    }
  },
  created: function() {},
  computed: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.localwarehouseid = userdetail.warehouseid

    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if (localStorage.getItem("selectedClient")!='undefined')
		{
    this.getMerchantList()
    this.getShippingList()
    }
    this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getShippingList();
		  });
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.showSelectMerchant=true;
        break;
        // this.getClientList();
        // this.getWarehouseList();


      case 'client_user':
        this.clientid = userdetail.clientid;
        // this.getWarehouseList();
        this.merchantList();
        this.showSelectWarehouse = true;
        this.showSelectMerchant=true
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        this.showSelectMerchant=true;

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError'));
        break
    }
  },
  methods: {
    selectMerchant(data){
			this.selectedmerchant = data;
			this.merchant = data.value;
		  },
///////////////////////////

getMerchantList() {
  var userToken = window.localStorage.getItem('userToken')
  var myStr = userToken.replace(/"/g, '');
  this.input = ({
    clientid: localStorage.getItem("selectedClient"),
  })
  axios({
      method: 'POST',
      'url': apiUrl.api_url + 'merchantList',
      'data': this.input,
      headers: {
        'Authorization': 'Bearer ' + myStr
      }
    })
    .then(result => {
      if (result.data && result.data.length > 0) {
        this.listMerchantData = result.data;
        this.merchantList.push({
          value:'',text: this.$t('common.selectMerchantPlaceHolder')}
         )
        for (var i = 0; i < this.listMerchantData.length; i++) {
          this.merchantList.push({
          'value': this.listMerchantData[i].merchantid,
          'text': this.listMerchantData[i].merchantname
          });
        }

      }
    }, error => {
      console.error(error)
    })
},


    //////////////////////////////////////////
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    dateformat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    //to get rto list
    getRtomarkedList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var FromDate;
      var ToDate;
      this.totalRows=0;
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
      if (this.fromdate == "" || this.fromdate == null) {
        FromDate = "";
      } else {
        FromDate = this.dateformat(this.fromdate) + ' 00:00:00';
      }
      if (this.todate == "" || this.todate == null) {
        ToDate = "";
      } else {
        ToDate = this.dateformat(this.todate) + ' 23:59:00';
      }
      this.input = ({
        offset:(this.currentPage - 1) * 10,
        limit: this.pageLimit,
        awbno: this.awbno.trim(),
        shippingcompany: this.shippingcompany.trim(),
        clientid: localStorage.getItem("selectedClient"),
        warehouseid: localStorage.getItem("selectedWarehouse"),
        orderid: this.orderid.trim(),
        merchantid: this.merchant,
        shippingid: this.shippingid.trim(),
        fromdate: FromDate,
        todate: ToDate,
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRtomarkedList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listRTOproductData = result.data.data;
          this.isLoading = false;
          this.totalRows = result.data.count;
          this.resultCount = result.data.count;
          if (this.totalRows > 0) {
            if (this.totalRows < this.pageLimit) {
              this.totalPage = 1
            } else {
              this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
            }
          }
        }, error => {
          console.error(error)
        })
    },
    getShippingList() {
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.WarehouseErr = this.$t('common.warehouseError');
        return false;
      }
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.pageno = 0;
      this.input = ({
        warehouseid: localStorage.getItem("selectedWarehouse"),
        clientid:localStorage.getItem("selectedClient"),
      });

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'courierMasterList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.shippingcompanyList = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },
    //to get RTO marked List
    searchRTOmarked() {
      if (this.orderid == "" && this.shippingcompany == "" && this.shippingid == "" && this.awbno == "" && this.fromdate == "" && this.todate) {
        return false;
      }
      if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
        this.pageno = this.pageCount = 0;
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
        this.pageno = this.pageCount = 0;
        return false;
      }
      this.resultCount = 0;
      this.currentPage = 1;
      this.totalPage = 0;
      this.searchFlag = true;
      this.getRtomarkedList();
    },

    // getWarehouseList() {
    //   var userToken = window.localStorage.getItem('userToken')
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageno = 0;

    //   this.input = ({
    //     clientid: this.clientid,
    //   });

    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //     .then(result => {
    //       this.listWarehouseData = result.data.data;
    //     }, error => {
    //       console.error(error)
    //     })
    // },
    // //to get Client list
    // getClientList() {
    //   var userToken = window.localStorage.getItem('userToken');
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageno = 0;

    //   this.input = ({
    //     warehouseid: this.warehouseid,
    //   });

    //   axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //     .then(result => {
    //       this.clientListData = result.data.data;
    //     }, error => {
    //       console.error(error);
    //     });
    // },

    // clientSelected() {
    //   if (this.clientid != this.client  ||this.clientid == this.client) {
    //     this.clientid = this.client;
    //     this.listMerchantData=[]
    //     this.merchant=''
    //     this.warehouse=''
    //     if (this.clientid)
    //     this.getMerchantList();
    //     // console.log(this.listRTOproductData.length)
    //     this.listWarehouseData = []
    //     this.merchantList=[]
		// 		this.selectedmerchant={}
    //     this.resultCount=''
    //     this.getWarehouseList();
    //     this.getShippingList();
    //     if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //       this.warehouse = this.warehouseid = '';
    //     }
    //   }
    //   this.searchFlag=false
    //   this.clientid = this.client;
    //   if (this.clientid) {
    //     this.merchantList=[]
		// 			this.selectedmerchant={}
    //    // this.resetSearchForm1();
    //     if (this.warehouseid) {

    //       //this.getRtomarkedList();
    //     } else {
    //       //this.getWarehouseList();
    //     }
    //   }
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       //this.getRtomarkedList();
    //       this.getShippingList();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },

    //to reset search form
    resetSearchForm1() {
      this.awbno = '';
      this.shippingcompany = '';
      this.selectedmerchant={}
      this.listRTOproductData = [];
      this.totalRows=0
      this.searchFlag = false;
      document.getElementById("awbno").value = "";
      //this.getRtomarkedList();
    },
    //to reset search form
    resetSearchForm() {
      this.awbno = '';
      this.WarehouseErr = '';
      this.ClientErr = '';
      this.shippingcompany = '';
      // this.clientid = '';
      this.orderid = '';
      this.shippingid = '';
      this.awbno = '';
      this.fromdate = '';
      this.todate = '';
      this.totalRows=0
      this.listRTOproductData = [];
      this.selectedmerchant={};
      this.searchFlag = false;
      this.resultCount = 0;
      this.pageno = 0;
      this.totalPage = 0;
      document.getElementById("orderid").value = "";
      document.getElementById("shippingid").value = "";
      document.getElementById("awbno").value = "";
      // if (this.user_type == 'warehouse_user')
      //   this.client = '';
      // else if (this.user_type == 'client_user')
      //   this.warehouse = '';
      // else {
      //   this.client = '';
      //   this.warehouse = '';
      // }
      //this.getRtomarkedList();
    },
    //to get pagination
    // getPaginationData(currentPage) {
    //   this.totalPage = (currentPage - 1) * this.pageLimit
    //   this.getRtomarkedList()
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getRtomarkedList()
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/rtomarked/rtolist/rtomarked.component.js